var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$store.getters['ajax/available'] === 'YES')?_c('v-btn',{staticClass:"btn-back",attrs:{"icon":""},on:{"click":_vm.goBack}},[_c('v-icon',{attrs:{"color":"secondary"}},[_vm._v("mdi-arrow-left")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }